module.exports = __webpack_public_path__ + "static/media/visa.7a07d141.svg";